import { render } from "./Sproof.vue?vue&type=template&id=61a58bb1&scoped=true"
import script from "./Sproof.vue?vue&type=script&lang=js"
export * from "./Sproof.vue?vue&type=script&lang=js"

import "./Sproof.vue?vue&type=style&index=0&id=61a58bb1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a58bb1"]])

export default __exports__